export default function debounce(func, delay) {
    let timer;
    return (...arg) => {
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            func(...arg);
        }, delay);
    };
};